import React, { useState } from 'react';
import { Dropdown, IDropdownOption } from '@fluentui/react';

interface IHourSelector {
  onChange: (val: string) => void;
  hour: number;
  minute: number;
  useHalf?: boolean;
  useLabel?: boolean;
  maxFirstSelector?: number;
  required?: boolean;
}

export const HourSelector = (props: IHourSelector) => {
  const [selectedHour, setSelectedHour] = useState<number>(props.hour);
  const [selectedMinute, setSelectedMinute] = useState<number>(props.minute);

  React.useEffect(() => {
    setSelectedHour(props.hour);
    setSelectedMinute(props.minute);
  }, [props.hour, props.minute]);

  const hours: IDropdownOption[] = [];
  for (let i = 0; i < (props.maxFirstSelector ? props.maxFirstSelector : 24); i++) {
    hours.push({ key: i.toString(), text: i.toString().padStart(2, '0') });
  }

  const minutes: IDropdownOption[] = [];
  for (let i = 0; i < 60; i++) {
    minutes.push({ key: i.toString(), text: i.toString().padStart(2, '0') });
  }

  const handleHourChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
    if (option) {
      setSelectedHour(Number(option.key));
    }
  };

  const handleMinuteChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
    if (option) {
      setSelectedMinute(Number(option.key));
    }
  };

  React.useEffect(() => {
    if (typeof selectedHour !== 'undefined' && typeof selectedMinute !== 'undefined') {
      props.onChange(
        selectedHour.toString().padStart(2, '0') + ':' + selectedMinute.toString().padStart(2, '0')
      );
    }
  }, [selectedHour, selectedMinute]);

  return (
    <>
      <div className={props.useHalf ? 'ms-Grid-col ms-sm6' : 'ms-Grid-col ms-sm1'} style={{ paddingLeft: 0 }}>
        <Dropdown
          label={props.useLabel ? (props.required ? 'Hora (*)' : 'Hora') : ''}
          options={hours}
          selectedKey={selectedHour?.toString()}
          onChange={handleHourChange}
        />
      </div>

      <div
        className={props.useHalf ? 'ms-Grid-col ms-sm6' : 'ms-Grid-col ms-sm1'}
        style={{ paddingRight: 0 }}
      >
        <Dropdown
          label={props.useLabel ? (props.required ? 'Minuto (*)' : 'Minuto') : ''}
          options={minutes}
          selectedKey={selectedMinute?.toString()}
          onChange={handleMinuteChange}
        />
      </div>
    </>
  );
};
